export class ErrorCodes {
  errorCodes!: { [key: string]: { [key: string]: string } };
}
